import React, { useState, useCallback, useRef, Fragment, useContext, useEffect } from 'react'
import { Modal, Button, Dropdown, Tabs, Tab } from 'react-bootstrap';
// import { Modal, Button, Dropdown, Tabs, Tab, Table } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import styles from './MultipleMsgSending.module.css';
import { ExcelRenderer } from 'react-excel-renderer';
// import dateFormat from "dateformat";
import { useTranslation } from "react-i18next";
import { isNumeric, replaceAll, deleteAreaCode, getNumberWithIsraelAreaCode, convertDateTimeToApplicationTime, formatDateFromDB } from '../../../util/functions'
import Spinner from '../../UI/Spinner/Spinner';
import AlertContext from '../../../context/AlertModelContext/AlertModalContext'
// imports for schedule messages
import Flatpickr from 'react-flatpickr';
import heLocale from 'flatpickr/dist/l10n/he';
import 'flatpickr/dist/themes/material_green.css';
import { sendMultipleMessages } from '../../../axios/requests/msgReq';
import { uploadFile } from '../../../axios/requests/filesReq'
import { multipleMsgChunkSize, itemsPerPagePagination } from '../../../settings'
import TemplateMsg from '../../UI/TemplateMsg/TemplateMsg';
import * as settings from '../../../settings'
import { getAllCampaigns, editCampaignActiveOrNo } from '../../../axios/requests/campaignReq';
// import PaginationComponent from '../../UI/Pagination/PaginationComponent';
import FileManager from '../FileManager/FileManager';
import Grid from '../../UI/Grid/Grid';
// const delayNow = ms => new Promise(resolve => setTimeout(resolve, ms))
// const delayTimeInMlSec = 500

const sendMediaSupportedTypes = settings.sendMediaSupportedTypes

const MultipleMsgSending = (props) => {
    //@@@@@@@@@@@@@@@@@@@useCase@@@@@@@@@@@@@@@@@@@
    const [t] = useTranslation('common')
    const alertCtx = useContext(AlertContext)
    const [selectedChannelState, setSelectedChannelState] = useState('whatsapp')
    const [colFileState, setColFileState] = useState([])
    const [rowFileState, setRowFileState] = useState([])
    const [campaignNameState, setCampaignNameState] = useState('')
    const [textAreaState, setTextAreaState] = useState('')
    const [matchingFieldsState, setMatchingFieldsState] = useState({})
    const [sendMsgToFileErrorState, setSendMsgToFileErrorState] = useState('')
    const [loadingStatusOnSendingMsgState, setLoadingStatusOnSendingMsgState] = useState(false)
    const [isMsgSentState, setIsMsgSentState] = useState(false)
    // const sendCampaignFileExpRef = useRef()
    const [fileToSendState, setFileToSendState] = useState()
    const [skipInvalidPhones, setSkipInvalidPhones] = useState(false)

    //
    const [showFileManagerState, setShowFileManager] = useState(false)
    const [fileCategoryLimitState, setFileCategoryLimit] = useState()
    //
    let fileExplorer = useRef()
    const { onHide } = props
    const onSendClicked = props.onSendClicked
    let attachToBeginMsg = props.attachToBeginMsg
    const loggedAgentName = props.loggedAgentName

    const [allCampaigns, setAllCampaigns] = useState([]);
    const [activeTab, setActiveTab] = useState('sendCampaign');
    let skippedRows = []

    //@@@@@@@@@@@@@@@@@@@Functions@@@@@@@@@@@@@@@@@@@

    //schedule messages
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(itemsPerPagePagination || 9);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentCampaigns = allCampaigns.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // const handleOnAttachFileToCampaignChanged = async (event) => {
    //     event.stopPropagation();
    //     event.preventDefault();
    //     const firstFile = event.target.files[0];

    //     setFileToSendState(firstFile)
    // }

    const toggleCalendar = () => {
        setShowCalendar(!showCalendar);
    };

    const dateSelectedHandler = (selectedDates) => {
        setSelectedDate(selectedDates[0]);
    };
    // end 

    const setMatchingFieldsObjectVariables = useCallback((text) => {
        let ObjectVariables = { phone: undefined }
        const firstParseStepArr = text.split("{{")

        for (let firstParseStepStr of firstParseStepArr) {
            const secondParseStepArr = firstParseStepStr.split("}}")
            for (let secondParseStepStr of secondParseStepArr) {
                if (secondParseStepArr.length === 2 && isNumeric(secondParseStepStr[0])) {
                    ObjectVariables['{{' + secondParseStepStr + '}}'] = undefined
                }
            }
        }
        setMatchingFieldsState(ObjectVariables)
    }, [setMatchingFieldsState])


    //todo add file to multiMsgSending
    const handleOnNewTextAreaState = useCallback((selectedTempMsg) => {
        //todo filemanager
        if (['image', 'video', 'document'].includes(selectedTempMsg.templateType)) {
            setShowFileManager(true)
            setFileCategoryLimit(selectedTempMsg.templateType)
            // sendCampaignFileExpRef.current.click();
        }

        setTextAreaState(selectedTempMsg.msg)
        setMatchingFieldsObjectVariables(selectedTempMsg.msg)
    }, [setTextAreaState, setMatchingFieldsObjectVariables])

    const handleOnNewCharCampaignName = (event) => {
        setCampaignNameState(event.target.value)
    }


    const onResetClicked = useCallback(() => {
        setSelectedChannelState('whatsapp')
        setColFileState([])
        setRowFileState([])
        setTextAreaState('')
        setCampaignNameState('')
        setMatchingFieldsState({})
        setSendMsgToFileErrorState('')
        setLoadingStatusOnSendingMsgState(false)
        setIsMsgSentState(false)
        if (fileExplorer.current) fileExplorer.current.value = null
    }, [])


    const handleOnNewChannelSelect = useCallback((channelName) => {
        // onResetClicked()
        setSelectedChannelState(channelName)
    }, [setSelectedChannelState, onResetClicked])

    const fileHandler = useCallback((event) => {
        try {
            let fileObj = event.target.files[0]
            if (fileObj && fileObj.type !== 'application/vnd.ms-excel' && fileObj.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && fileObj.name && !fileObj.name.includes('.csv')) {
                alertCtx.showAlert(t('error'), t('Support for .csv, .xls, .xlsx formats'), 'sm')
                if (fileExplorer.current) fileExplorer.current.value = null
                return
            }
            //parse file to obj   
            if (fileObj) {
                ExcelRenderer(fileObj, (err, resp) => {
                    if (err) {
                        console.log(err);
                        throw new Error(err)
                    }
                    else {

                        let rowsCopy = [...resp.rows].filter(rowItem => {
                            if (rowItem.length > 0) return true
                            return false
                        })


                        setColFileState([...resp.rows[0]])
                        setRowFileState(rowsCopy.splice(1, rowsCopy.length))
                    }
                })
            }
        }
        catch (e) {
            console.log(e)
        }
    }, [alertCtx])

    const handleOnHide = useCallback(() => {
        onResetClicked()
        onHide()
        setActiveTab('sendCampaign');
    }, [onHide, onResetClicked])

    //validate sending data
    const isDataValide = useCallback(() => {
        if (!campaignNameState) {
            alertCtx.showAlert(t('error'), t('Please write campaign name'), 'sm')
            return false
        }
        if (!fileExplorer.current.value) {
            // alert(t('Please select file'))
            alertCtx.showAlert(t('error'), t('Please select file'), 'sm')
            return false
        }
        if (textAreaState.length < 5) {
            // alert(t('msg must contain min 5 chars'))
            alertCtx.showAlert(t('error'), t('msg must contain min 5 chars'), 'sm')
            return false
        }
        if (!matchingFieldsState.phone) {
            // alert(t('Please select phone number column'))
            alertCtx.showAlert(t('error'), t('Please select phone number column'), 'sm')
            return false
        }
        if (!selectedChannelState) {
            // alert(t('please select channel'))
            alertCtx.showAlert(t('error'), t('please select channel'), 'sm')
            return false
        }
        const columnFields = Object.keys(matchingFieldsState)
        for (let columnField of columnFields) {
            if (!matchingFieldsState[columnField]) {
                // alert(t('please associate column to param') + ' ' + columnField)
                alertCtx.showAlert(t('error'), t('please associate column to param') + ' ' + columnField, 'sm')
                return false
            }
        }
        return true
    }, [t, alertCtx, matchingFieldsState, textAreaState, fileExplorer, selectedChannelState])
    //Todo colTitle, colField, index, keyHeb

    const createMappedArr = (contactsArr, msgType, scheduleTime, attachToBeginMsg, loggedAgentName, opt) =>
        contactsArr.map((contact) => ({
            clientName: getNumberWithIsraelAreaCode(contact.phone),
            msgType,
            msgBody: attachToBeginMsg ? attachToBeginMsg.replace('{name}', loggedAgentName) + ' ' + contact.MsgToSend : contact.MsgToSend,
            scheduleTime
        }))

    //handle Array of contactToSendMsgArr - need to do transformation
    const sendMsg = useCallback(async (contactToSendsMsgArr, fileId) => {
        const opt = { completed: false, isPublic: false, isMailingListMsg: true }
        const scheduleTime = (selectedDate.getTime() - Date.now()) < 60000 ? undefined : selectedDate
        const mappedArr = createMappedArr(contactToSendsMsgArr, selectedChannelState, scheduleTime, attachToBeginMsg, loggedAgentName)

        const reqBody = {
            campaignName: campaignNameState,
            contactsList: mappedArr,
            campaignMsg: textAreaState,
            msgType: selectedChannelState,
            fileId
        }
        //Todo Dima add catch
        await sendMultipleMessages(reqBody)

    }, [selectedChannelState, onSendClicked, attachToBeginMsg, loggedAgentName, selectedDate, campaignNameState, textAreaState, selectedChannelState]);

    // handle single contactToSendMsg
    // const sendMsg = useCallback((contactToSendsMsg) => {
    //     let opt = { completed: false, isPublic: false, isMailingListMsg: true }
    //     let msg = contactToSendsMsg.MsgToSend
    //     // if (attachToBeginMsg === 'name') {
    //     //     msg = loggedAgentName + ' : ' + msg
    //     // }
    //     if (attachToBeginMsg) {
    //         msg = attachToBeginMsg.replace('{name}', loggedAgentName) + ' ' + msg
    //     }
    //     let scheduleTime = (selectedDate.getTime() - Date.now()) < 60000 ? undefined : selectedDate
    //     const clientName = getNumberWithIsraelAreaCode(contactToSendsMsg.phone)
    //     onSendClicked(clientName, selectedChannelState, msg, undefined, opt, undefined, scheduleTime);
    // }, [selectedChannelState, onSendClicked, attachToBeginMsg, loggedAgentName, selectedDate])

    const handleOnSendButtonClicked = useCallback(async () => {

        // if (rowFileState.length > 50) {
        //     alert('You can only send a maximum of 50 messages at a time.');
        //     return;
        // }
        try {
            //validate sending data
            if (!isDataValide()) {
                return
            }
            setLoadingStatusOnSendingMsgState(true)
            //check if there is addition phone number, if there is add new record of the contact to the list
            let toUseRowFileState = [...rowFileState]
            let contactsToSendsMsgArr = []
            let sendMsgToFileError = ''
            let rowNumber = 1
            //loop over all file rows
            for (let contact of toUseRowFileState) {
                const columnFields = Object.keys(matchingFieldsState)
                let phone = undefined
                let MsgToSend = textAreaState
                let rowHasError = false

                for (let columnField of columnFields) {
                    const fieldIndex = matchingFieldsState[columnField]?.index;
                    const fieldValue = contact[fieldIndex];

                    if (!fieldValue) {
                        sendMsgToFileError += `File row ${rowNumber}) Column "${matchingFieldsState[columnField].colField}" was empty\n`;
                        rowHasError = true
                        break
                    }

                    if (columnField === 'phone') {
                        phone = deleteAreaCode(replaceAll(replaceAll(fieldValue.toString(), '-', ''), ' ', ''))
                        if (phone[0] !== '0') phone = '0' + phone
                        contact[fieldIndex] = phone
                        const isInvalidPhone = !phone || phone.length < 9 || phone.length > 10 || !/^\d+$/.test(phone) || phone.substring(0, 2) !== '05';

                        if (isInvalidPhone) {
                            if (skipInvalidPhones) {
                                skippedRows.push({ rowNumber, phone });
                                rowHasError = true;
                                break;
                            } else {
                                sendMsgToFileError += `File row ${rowNumber}) Wrong phone number "${phone}" column "${matchingFieldsState[columnField].colField}"\n`;
                                rowHasError = true;
                                break;
                            }
                        }
                    }

                    MsgToSend = replaceAll(MsgToSend, columnField, fieldValue);
                }

                if (!rowHasError) {
                    contactsToSendsMsgArr.push({ phone, MsgToSend, rowNumber })
                }

                rowNumber++
            }
            if (sendMsgToFileError !== '') {
                setSendMsgToFileErrorState(sendMsgToFileError);
                setLoadingStatusOnSendingMsgState(false);
            } else {
                let fileId
                if (fileToSendState) { // todo filemanager
                    if (fileToSendState._id) {// is uploaded file
                        fileId = fileToSendState._id
                    }
                    else { // is to upload and send
                        const fileData = await uploadFile(fileToSendState)
                        fileId = fileData._id
                    }
                    // if (fileExplorer?.current?.value) fileExplorer.current.value = null


                    setFileToSendState()
                }

                const chunkSize = multipleMsgChunkSize;
                const chunksArray = [];
                for (let i = 0; i < contactsToSendsMsgArr.length; i += chunkSize) {
                    chunksArray.push(contactsToSendsMsgArr.slice(i, i + chunkSize));
                }
                for (let chunk of chunksArray) {
                    await sendMsg(chunk, fileId);
                }

                setIsMsgSentState(true);
                if (skipInvalidPhones && skippedRows.length > 0) {
                    let skippedText = skippedRows.map(item => `Row ${item.rowNumber}: ${item.phone}`).join('\n');
                    alertCtx.showAlert(t('info'), t('skippedInvalidPhonesMessage', { count: skippedRows.length, skippedText }), 'lg', true);
                }
                setLoadingStatusOnSendingMsgState(false);
            }
        } catch (error) {
            console.error('Error sending chunk:', error);
            setIsMsgSentState(false);
            setLoadingStatusOnSendingMsgState(false);
        }
    }, [rowFileState, textAreaState, matchingFieldsState, isDataValide, sendMsg, skipInvalidPhones]);


    const onColFieldSelected = (colTitle, colField, index) => {//colTitle:name in system,colField:name in file,index:place of the colField in array [rowFileState]
        setMatchingFieldsState({ ...matchingFieldsState, [colTitle]: { colField: colField, index: index } })
    }

    const handleOnTextAreaChange = useCallback((event) => {
        setTextAreaState(event.target.value)
        setMatchingFieldsObjectVariables(event.target.value)
    }, [setTextAreaState, setMatchingFieldsObjectVariables])

    //@@@@@@@@@@@@@@@@@@@variables@@@@@@@@@@@@@@@@@@@

    let propertyRows = Object.keys(matchingFieldsState).map((key, index) => {
        let title = key + ':'
        if (key === 'phone') {
            title = t('Phone') + ':'
        }
        return (
            <Fragment key={index + 'Frag'}>
                <div className={[styles.propertyRow]} key={index}>
                    <p className={styles.colTitle} key={index + '1'}>{title}</p>
                    <Dropdown key={index + '2'}>
                        <Dropdown.Toggle className={styles.DropdownButton} variant="info" id="dropdown-basic">{!matchingFieldsState[key] ? `${t('Empty')} ` : matchingFieldsState[key].colField + ' '}</Dropdown.Toggle>
                        <Dropdown.Menu>
                            {colFileState.map((colField, index) => <Dropdown.Item onClick={() => onColFieldSelected(key, colField, index)}>{colField}</Dropdown.Item>)}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </Fragment>
        )
    })

    // let whatsappVerifiedTempList = undefined
    // let regularTempMsgList
    // // if (props.tempMsgs !== [] && props.tempMsgs !== undefined) {
    // if (props.tempMsgs && Array.isArray(props.tempMsgs) && props.tempMsgs.length > 0) {
    //     whatsappVerifiedTempList = props.tempMsgs.map((tempMsg) => {
    //         if (tempMsg.whatsappVerified && tempMsg.display && tempMsg.supportMailingList) return <p className='templateItem' key={tempMsg._id} onClick={() => handleOnNewTextAreaState(tempMsg)}>{tempMsg.msg}</p>
    //         else return null
    //     })
    //     regularTempMsgList = props.tempMsgs.map((tempMsg) => {
    //         if (!tempMsg.whatsappVerified && tempMsg.display) return <p className='templateItem' key={tempMsg._id} onClick={() => handleOnNewTextAreaState(tempMsg)}>{tempMsg.msg}</p>
    //         else return null
    //     })
    // }

    useEffect(() => {
        if (activeTab === 'seeCampaigns') {
            const fetchCampaigns = async () => {
                const response = await getAllCampaigns();
                if (response && response.status === "success") {
                    let responseData = response.data.data;
                    setAllCampaigns(responseData);
                } else {
                    setAllCampaigns([]);
                }
            };
            fetchCampaigns();
        }
    }, [activeTab]);

    const truncateText = (text, maxLength = 30) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substr(0, maxLength) + '...';
    }

    const handleToggleActive = async (campaignId, isActive) => {
        const updatedStatus = !isActive;
        try {
            await editCampaignActiveOrNo(campaignId, { isActive: updatedStatus });
            setAllCampaigns(prevCampaigns =>
                prevCampaigns.map(campaign =>
                    campaign._id === campaignId ? { ...campaign, isActive: updatedStatus } : campaign
                )
            );
        } catch (e) {
            console.error('Error updating campaign status', e);
        }
    };

    const tabTitles = {
        sendCampaign: t('Send Campaign'),
        seeCampaigns: t('See All My Campaigns')
    };

    const onAttachFilesToMessageFromFileManagerClickHandler = (fileArr = []) => { //getting files after it was added to galler
        if (fileArr?.length > 0) {
            setFileToSendState(fileArr[0])
        }
        setShowFileManager(false)
    }

    const onAttachFilesWithoutGalleryHandler = (fileArr = []) => {// getting  file array from fileExplorer input
        if (fileArr?.length > 0) {
            setFileToSendState(fileArr[0])
        }
        setShowFileManager(false)
    }

    const headers = [
        { label: t('Campaign Sql Id'), className: 'campaignSqlId' },
        { label: t('Campaign Name'), className: 'campaignName' },
        { label: t('Campaign Message'), className: 'campaignMessage' },
        { label: t('Campaign Contacts Count'), className: 'campaignContactsCount' },
        { label: t('Campaign Status'), className: 'campaignStatus' },
        { label: t('Campaign MsgType'), className: 'campaignMsgType' },
        { label: t('Campaign Creation Time'), className: 'campaignCreationTime' },
        { label: t('Campaign Stop Or Start'), className: 'campaignStopOrStart' },
    ];

    const renderRow = (campaign) => (
        <tr key={campaign._id}>
            <td>{campaign.sqlCampaignId}</td>
            <td>{campaign.name}</td>
            <td>{truncateText(campaign.msg)}</td>
            <td>{campaign.contactsCount}</td>
            <td>{campaign.isActive ? t('Campaign Active') : t('Campaign No Active')}</td>
            <td>{campaign.msgType}</td>
            <td>{formatDateFromDB(campaign.createDate)}</td>
            <td>
                <i
                    className={`fa-solid ${campaign.isActive ? 'fa-circle-stop' : 'fa-circle-play'} ${styles.iconClickable}`}
                    title={campaign.isActive ? t('Campaign Stop') : t('Campaign Start')}
                    onClick={() => handleToggleActive(campaign._id, campaign.isActive)}
                ></i>
            </td>
        </tr>
    );

    return (
        <Modal
            show={props.show}
            onHide={!loadingStatusOnSendingMsgState ? handleOnHide : () => { }}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName={[styles.largeModal]}
            className={[styles.modalRTL].join(' ')}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">{tabTitles[activeTab]}</Modal.Title>
            </Modal.Header>
            <Modal.Body className={[styles.modalRTL, styles.mainModalBody].join(' ')}>
                {isMsgSentState ? (
                    <div className={[styles.modalBodySection].join(' ')}>
                        <div className={[styles.propertyRow]}>
                            <p className={[styles.paramTitle]}>{t('Msg sent successfully')}</p>
                            <i className={"fas fa-check-square " + styles.msgsSentSuccessful} />
                        </div>
                    </div>
                ) : (
                    !loadingStatusOnSendingMsgState &&
                    sendMsgToFileErrorState === '' &&
                    !isMsgSentState && (
                        <div>
                            <Tabs className='cusTabs-contactlist open-contact-modal-tabs' defaultActiveKey="sendCampaign" id="send-campaign-tabs" activeKey={activeTab} onSelect={(currentTab) => setActiveTab(currentTab)} >
                                <Tab tabClassName='details-tab tab-border' eventKey="sendCampaign" title={t('Send Campaign')}>
                                    <div className={styles.scrollableContent}>
                                        <div className={[styles.modalBodySection].join(' ')}>
                                            <div className={[styles.propertyRow]}>
                                                <p className={styles.paramTitle}>{t('Campaign Name')}</p>
                                                <input
                                                    onChange={handleOnNewCharCampaignName}
                                                    value={campaignNameState}
                                                    className={styles['regular-input']}
                                                ></input>
                                            </div>

                                            <div className={[styles.propertyRow]}>
                                                <p className={[styles.paramTitle]}>{t('Select channel')}</p>
                                                <Dropdown>
                                                    <Dropdown.Toggle className={styles.DropdownButton} variant="info" id="dropdown-basic">
                                                        {t(selectedChannelState)}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className={styles.DropdownMenu}>
                                                        <Dropdown.Item onClick={() => handleOnNewChannelSelect('whatsapp')}>
                                                            {t('whatsapp')}
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => handleOnNewChannelSelect('sms')}>{t('sms')}</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>

                                            <div className={[styles.propertyRow]}>
                                                <p className={[styles.paramTitle]}>{t('Select template msg')}</p>
                                                <TemplateMsg
                                                    filterCondition="supportMailingList"
                                                    drop="left"
                                                    isLimitedOnlyForWhatsapp={selectedChannelState === 'whatsapp'}
                                                    tempMsgs={props.tempMsgs}
                                                    templateMessageClickHandler={handleOnNewTextAreaState}
                                                >
                                                    <Dropdown.Toggle className={styles.DropdownButton} variant="info" id="dropdown-basic">
                                                        {t('Select')}
                                                    </Dropdown.Toggle>
                                                </TemplateMsg>
                                            </div>

                                            {/* Mulitply Schedule sending with date and time */}
                                            <div className={[styles.propertyRow]}>
                                                <p className={[styles.paramTitle]}>
                                                    {t('Schedule sending')}{' '}
                                                    <i
                                                        onClick={() => {
                                                            alertCtx.showAlert(
                                                                t('info'),
                                                                t('The default for sending multiple messages is the current date and time. To send scheduled multiple messages, please select a date and time.'),
                                                                'sm'
                                                            );
                                                        }}
                                                        className={"fas fa-question-circle " + styles.questionMark}
                                                    />
                                                </p>
                                                <Dropdown show={showCalendar} onToggle={toggleCalendar} drop="left">
                                                    <Dropdown.Toggle
                                                        className={`${styles['btn-primary']} ${styles['dropdown-toggle']} ${styles['caret-off']}`}
                                                    >
                                                        {convertDateTimeToApplicationTime(selectedDate)}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <div>
                                                            <Flatpickr
                                                                id="notification-time-picker"
                                                                options={{
                                                                    locale: heLocale.he, // use hebrew locale
                                                                    time_24hr: true,
                                                                    enableTime: true,
                                                                    defaultDate: selectedDate,
                                                                    minDate: 'today',
                                                                    inline: true, // display a smaller calendar directly in the dropdown
                                                                    dateFormat: 'd/m/Y H:i', // format date and time in hebrew
                                                                }}
                                                                value={selectedDate}
                                                                onChange={dateSelectedHandler}
                                                            />
                                                            <div className={styles['button-container']}>
                                                                <Button
                                                                    onClick={() => {
                                                                        toggleCalendar();
                                                                        setSelectedDate(new Date());
                                                                    }}
                                                                    variant="secondary"
                                                                >
                                                                    {t('cancel')}
                                                                </Button>
                                                                <Button onClick={toggleCalendar} variant="success">
                                                                    {t('confirm')}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                            {/* end of Mulitply Schedule sending with date and time */}

                                            <div className={[styles.propertyRow]}>
                                                <p className={styles.paramTitle}>
                                                    {t('Enter your msg here')}
                                                    <i
                                                        onClick={() => {
                                                            alertCtx.showAlert(
                                                                t('info'),
                                                                t('Adding Parameters\n\n1. Adding variable parameters is designed to enable sending personalized messages to customers when sending messages to a group.\n2. Select the channel type and write or select the message for sending. Insert the variable parameters into the message body and number them, for example: Hello {{1}}, your subscription expires on: {{2}}.\n3. Each time you insert a parameter, an empty field is automatically created and associated with the numbered parameter. This field is intended to link the selected column from the file to the parameter.\n4. Upload the selected file for sending.\n5. From the empty field of each parameter, link it to the selected column from the file by clicking on the field.'),
                                                                'sm'
                                                            );
                                                        }}
                                                        className={"fas fa-question-circle " + styles.questionMark}
                                                    />
                                                </p>
                                                <textarea
                                                    onChange={handleOnTextAreaChange}
                                                    disabled={selectedChannelState === 'whatsapp'}
                                                    value={textAreaState}
                                                    className={styles.enterTextHereTextArea}
                                                ></textarea>
                                            </div>

                                            <div className={styles.propertyRow}>
                                                <p className={styles.paramTitle}>
                                                    {t('Skip invalid phone numbers')}
                                                    <i onClick={() => alertCtx.showAlert(t('info'), t('If enabled, numbers with wrong format (e.g. landlines, symbols, wrong length) will be skipped'), 'sm')}
                                                        className={`fas fa-question-circle ${styles.questionMark}`}
                                                    />
                                                </p>
                                                <Dropdown>
                                                    <Dropdown.Toggle className={styles.DropdownButton} variant="info" id="dropdown-skip-invalid">
                                                        {skipInvalidPhones ? t('yes') : t('no')}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className={styles.DropdownMenu}>
                                                        <Dropdown.Item onClick={() => setSkipInvalidPhones(true)}>{t('yes')}</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => setSkipInvalidPhones(false)}>{t('no')}</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>

                                            <div className={[styles.propertyRow]}>
                                                <p className={styles.paramTitle}>
                                                    {t('Select file')}
                                                    <i
                                                        onClick={() => {
                                                            alertCtx.showAlert(t('info'), this.props.t('Support for .csv, .xls, .xlsx formats'), 'sm');
                                                        }}
                                                        className={"fas fa-question-circle " + styles.questionMark}
                                                    />
                                                </p>
                                                <input
                                                    className={[styles.fileSelector]}
                                                    type="file"
                                                    accept=".csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                    ref={fileExplorer}
                                                    onChange={fileHandler}
                                                />
                                            </div>

                                            {/* <input
                                                className="fileSelector"
                                                type="file"
                                                accept={sendMediaSupportedTypes['whatsapp']}
                                                ref={sendCampaignFileExpRef}
                                                onChange={handleOnAttachFileToCampaignChanged}
                                            /> */}
                                            {showFileManagerState &&
                                                <FileManager
                                                    onHide={() => setShowFileManager((prevState) => !prevState)}
                                                    mediaTokenData={props.mediaTokenData}
                                                    permissionType={props.permissionType}
                                                    settings={props.settings}
                                                    onAttachFilesClicked={onAttachFilesToMessageFromFileManagerClickHandler}
                                                    onAttachFilesWithoutGalleryClicked={onAttachFilesWithoutGalleryHandler}
                                                    fileTypesLimit={sendMediaSupportedTypes['whatsapp']}
                                                    fileCategoryLimit={fileCategoryLimitState}
                                                />
                                            }
                                            {propertyRows.length > 0 ? (
                                                <Fragment>
                                                    <div className={[styles.propertyRow]}>
                                                        <p className={styles.enterTextHereTitle}>{t('Field mapping')}:</p>
                                                    </div>
                                                    {propertyRows}
                                                </Fragment>
                                            ) : null}
                                        </div>
                                    </div>
                                </Tab>

                                <Tab tabClassName='details-tab tab-border' eventKey="seeCampaigns" title={t('See All My Campaigns')}>
                                    <div className={[styles.spaceTable]}>
                                        <Grid
                                            headers={headers}
                                            data={currentCampaigns}
                                            renderRow={renderRow}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={allCampaigns.length}
                                            paginate={paginate}
                                            currentPage={currentPage}
                                            headerStyles={styles}
                                        />
                                    </div>
                                </Tab>

                            </Tabs>
                        </div>
                    )
                )}
                {loadingStatusOnSendingMsgState && (
                    <div className={[styles.modalBodySection].join(' ')}>
                        <div className={[styles.propertyRow]}>
                            <p className={[styles.paramTitle]}>{t('Sends msgs. please do not turn off window while loading')}</p>
                        </div>
                        <div className={[styles.propertyRow]}>
                            <Spinner />
                        </div>
                    </div>
                )}
                {sendMsgToFileErrorState !== '' && (
                    <div className={[styles.modalBodySection].join(' ')}>
                        <div className={[styles.propertyRow]}>
                            <p className={[styles.paramTitle]}>{t('Error on file load')}</p>
                            <textarea disabled value={sendMsgToFileErrorState} className={styles.onErrorTextArea}></textarea>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className={[styles.modalLTR].join(' ')}>
                {!isMsgSentState && !loadingStatusOnSendingMsgState && sendMsgToFileErrorState === '' && (
                    <Button variant="success" onClick={handleOnSendButtonClicked}>
                        {t('Send')}
                    </Button>
                )}
                {(sendMsgToFileErrorState !== '' || isMsgSentState) && (
                    <Button onClick={onResetClicked}>{t('Back')}</Button>
                )}
                <Button className="mr-auto" variant="secondary" onClick={!loadingStatusOnSendingMsgState ? handleOnHide : () => { }}>
                    {t('Exit')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default MultipleMsgSending